import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'edcom-ui';
import styles from 'edcom-ui/components/Filters/Filters.module.less';
import filterStyles from 'edcom-ui/components/Filters/Tree/TreeFilter.module.less';
import fListStyles from 'edcom-ui/components/Filters/Tree/TreeFilterList.module.less';
import { trackGA } from '../../../services/track';
import clsx from 'clsx';

export default function SelectedContentFacet({
  selected,
  unSelect,
  showOnlySelected,
  setShowOnlySelected,
}) {
  let plural = selected.length > 1 ? 's' : '';
  let filterDisplay = selected.length + ' selection' + plural;

  let facetViewDisplay = showOnlySelected
    ? 'Back to View All'
    : 'View ' + filterDisplay;

  const iconName = selected ? 'cancel-circled' : null;
  const iconClass = selected ? styles.removeIcon : null;

  const classes = clsx(filterStyles.link, filterStyles.selection, {
    [filterStyles.selected]: selected,
  });

  const handleViewSelectionClicked = () => {
    if (!showOnlySelected) {
      trackGA('Search', 'View Selection clicked');
    }
    setShowOnlySelected(!showOnlySelected);
  };

  return (
    <div className={clsx(styles.searchFilter)}>
      <ul className={clsx(fListStyles.facets, fListStyles.topLevel)}>
        <li className={filterStyles.facet}>
          <div className={classes} role="link" title="Un-selected" tabIndex="0">
            <Icon
              name={iconName}
              className={clsx(filterStyles.icon, iconClass)}
              onClick={() => {
                unSelect([]);
              }}
            />
            {selected.length} selected
          </div>
        </li>
        <li className={filterStyles.facet}>
          <a className="Facet-module_link" onClick={handleViewSelectionClicked}>
            {facetViewDisplay}
          </a>
        </li>
      </ul>
    </div>
  );
}

SelectedContentFacet.propTypes = {
  selected: PropTypes.array,
  unSelect: PropTypes.func,
  showOnlySelected: PropTypes.bool,
  setShowOnlySelected: PropTypes.func,
};
